<template>
    <div>
        <div class="mb-8">
            <div class="w-full flex flex-col shadow-md bg-white rounded">
                <div
                    class="flex flex-row rounded-t p-2 justify-between">
                    <span class="pl-2">Recent Projects</span>

                    <div class="flex flex-row">
                        <div class="bg-grey-lighter px-3 rounded-full mr-3">
                            <input ref="filter" type="search"
                                   class="bg-grey-lighter focus:outline-none rounded text-xs text-grey-darkest"
                                   placeholder="Search Projects" @input="debounceFilterProjects"
                                   v-model="projectFilter">
                            <i v-if="loadingProjects" class="fa fa-spin fa-spinner text-grey-darkest"
                               aria-hidden="true"></i>
                        </div>
                        <button v-if="canEdit" @click="addProject"
                                class="border-2 border-followup-nav focus:outline-none hover:bg-followup-nav rounded-full">
                            <span class="font-semibold hover:text-white material-icons p-1 text-followup-nav text-xs">add</span>
                        </button>

                    </div>
                </div>
                <div class="table-responsive">
                    <table class="text-left w-full">
                        <div class="recent-files">
                            <thead>
                            <tr>
                                <th class="py-1 px-2 border-b border-grey-light">
                                    <button
                                        class="font-medium uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                        :class="currentProjectOrder.property === 'sequential_team_id' ? 'text-teal' : ''"
                                        @click="sortByColumn('sequential_team_id')">
                                        ID
                                        <i class="fa fa-xs fa-chevron-down"
                                           v-if="currentProjectOrder.property === 'sequential_team_id' && currentProjectOrder.direction === 'desc'"></i>
                                        <i class="fa fa-xs fa-chevron-up"
                                           v-if="currentProjectOrder.property === 'sequential_team_id' && currentProjectOrder.direction === 'asc'"></i>
                                    </button>
                                </th>
                                <th class="border-b border-grey-light">
                                    <button
                                        class="font-medium uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                        :class="currentProjectOrder.property === 'name' ? 'text-teal' : ''"
                                        @click="sortByColumn('name')">
                                        Project Name
                                        <i class="fa fa-xs fa-chevron-down"
                                           v-if="currentProjectOrder.property === 'name' && currentProjectOrder.direction === 'desc'"></i>
                                        <i class="fa fa-xs fa-chevron-up"
                                           v-if="currentProjectOrder.property === 'name' && currentProjectOrder.direction === 'asc'"></i>
                                    </button>
                                </th>
                                <th class="py-1 px-2 border-b border-grey-light">
                                    <button
                                        class="font-medium uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                        :class="currentProjectOrder.property === 'address' ? 'text-teal' : ''"
                                        @click="sortByColumn('address')">
                                        Address
                                        <i class="fa fa-xs fa-chevron-down"
                                           v-if="currentProjectOrder.property === 'address' && currentProjectOrder.direction === 'desc'"></i>
                                        <i class="fa fa-xs fa-chevron-up"
                                           v-if="currentProjectOrder.property === 'address' && currentProjectOrder.direction === 'asc'"></i>
                                    </button>
                                </th>
                                <th class="py-1 px-2 border-b border-grey-light">
                                    <button
                                        class="font-medium uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                        :class="currentProjectOrder.property === 'contact' ? 'text-teal' : ''"
                                        @click="sortByColumn('contact')">
                                        Contact
                                        <i class="fa fa-xs fa-chevron-down"
                                           v-if="currentProjectOrder.property === 'contact' && currentProjectOrder.direction === 'desc'"></i>
                                        <i class="fa fa-xs fa-chevron-up"
                                           v-if="currentProjectOrder.property === 'contact' && currentProjectOrder.direction === 'asc'"></i>
                                    </button>
                                </th>
                                <th class="py-1 px-2 border-b border-grey-light">
                                    <button
                                        class="font-medium uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                        :class="currentProjectOrder.property === 'sales_status' ? 'text-teal' : ''"
                                        @click="sortByColumn('sales_status')">
                                        {{ getFieldLabel(fieldLabels, 'sales-status')}}
                                        <i class="fa fa-xs fa-chevron-down "
                                           v-if="currentProjectOrder.property === 'sales_status' && currentProjectOrder.direction === 'desc'"></i>
                                        <i class="fa fa-xs fa-chevron-up"
                                           v-if="currentProjectOrder.property === 'sales_status' && currentProjectOrder.direction === 'asc'"></i>
                                    </button>
                                </th>
                                <th class="py-1 px-2 border-b border-grey-light">
                                    <button
                                        class="font-medium uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                        :class="currentProjectOrder.property === 'account_manager' ? 'text-teal' : ''"
                                        @click="sortByColumn('account_manager')">
                                        {{ getFieldLabel(fieldLabels, 'account-manager')}}
                                        <i class="fa fa-xs fa-chevron-down "
                                           v-if="currentProjectOrder.property === 'account_manager' && currentProjectOrder.direction === 'desc'"></i>
                                        <i class="fa fa-xs fa-chevron-up "
                                           v-if="currentProjectOrder.property === 'account_manager' && currentProjectOrder.direction === 'asc'"></i>
                                    </button>
                                </th>
                                <th class="py-1 px-2 border-b border-grey-light">
                                    <button
                                        class="font-medium uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                        :class="currentProjectOrder.property === 'estimator' ? 'text-teal' : ''"
                                        @click="sortByColumn('estimator')">
                                        {{ getFieldLabel(fieldLabels, 'estimator')}}
                                        <i class="fa fa-xs fa-chevron-down "
                                           v-if="currentProjectOrder.property === 'estimator' && currentProjectOrder.direction === 'desc'"></i>
                                        <i class="fa fa-xs fa-chevron-up"
                                           v-if="currentProjectOrder.property === 'estimator' && currentProjectOrder.direction === 'asc'"></i>
                                    </button>
                                </th>
                                <th class="py-1 px-2 border-b border-grey-light">
                                    <button
                                        class="font-medium uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                        :class="currentProjectOrder.property === 'bid_date' ? 'text-teal' : ''"
                                        @click="sortByColumn('bid_date')">
                                        {{ getFieldLabel(fieldLabels, 'bid-date')}}
                                        <i class="fa fa-xs fa-chevron-down ml-2"
                                           v-if="currentProjectOrder.property === 'bid_date' && currentProjectOrder.direction === 'desc'"></i>
                                        <i class="fa fa-xs fa-chevron-up ml-2"
                                           v-if="currentProjectOrder.property === 'bid_date' && currentProjectOrder.direction === 'asc'"></i>
                                    </button>
                                </th>
                                <th class="py-1 px-2 border-b border-grey-light">
                                    <button
                                        class="font-medium uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                        :class="currentProjectOrder.property === 'base_bid' ? 'text-teal' : ''"
                                        @click="sortByColumn('base_bid')">
                                        Base Bid
                                        <i class="fa fa-xs fa-chevron-down"
                                           v-if="currentProjectOrder.property === 'base_bid' && currentProjectOrder.direction === 'desc'"></i>
                                        <i class="fa fa-xs fa-chevron-up"
                                           v-if="currentProjectOrder.property === 'base_bid' && currentProjectOrder.direction === 'asc'"></i>
                                    </button>
                                </th>
                                <th class="py-1 px-2 border-b border-grey-light">
                                    <button
                                        class="font-medium uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                        :class="currentProjectOrder.property === 'contract_date' ? 'text-teal' : ''"
                                        @click="sortByColumn('contract_date')">
                                        Contract Date
                                        <i class="fa fa-xs fa-chevron-down"
                                           v-if="currentProjectOrder.property === 'contract_date' && currentProjectOrder.direction === 'desc'"></i>
                                        <i class="fa fa-xs fa-chevron-up"
                                           v-if="currentProjectOrder.property === 'contract_date' && currentProjectOrder.direction === 'asc'"></i>
                                    </button>
                                </th>
                                <th class="py-1 px-2 border-b border-grey-light">
                                    <button
                                        class="font-medium uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                        :class="currentProjectOrder.property === 'contract_amount' ? 'text-teal' : ''"
                                        @click="sortByColumn('contract_amount')">
                                        Contract Amount
                                        <i class="fa fa-xs fa-chevron-down"
                                           v-if="currentProjectOrder.property === 'contract_amount' && currentProjectOrder.direction === 'desc'"></i>
                                        <i class="fa fa-xs fa-chevron-up"
                                           v-if="currentProjectOrder.property === 'contract_amount' && currentProjectOrder.direction === 'asc'"></i>
                                    </button>
                                </th>
                            </tr>
                            </thead>
                            <tbody class="bg-white">
                            <tr @click="editProject(project)"
                                class="cursor-pointer hover:bg-grey-lightest border-b border-grey-light"
                                v-for="project in projects">
                                <td v-if="project.custom_project_id" class="text-xs text-grey-darkest py-1 px-2">
                                    <div class="text-xs">{{ project.custom_project_id }}</div>
                                </td>
                                <td v-else class="text-xs text-grey-darkest py-1 px-2">
                                    <div class="text-xs">{{ project.sequential_team_id }}</div>
                                </td>
                                <td class="text-xs text-grey-darkest py-1 px-2" style="word-break: break-all">
                                    <div class="text-xs">{{ project.name }}</div>
                                </td>
                                <td class="text-xs text-grey-darkest py-1 px-2" style="word-break: break-all">
                                    <div class="text-xs">{{ project.address ? project.address : '-' }}</div>
                                </td>
                                <td class="text-xs text-grey-darkest py-1 px-2" style="word-break: break-all">
                                    <div class="text-xs">{{ project.contact ? project.contact : '-' }}</div>
                                </td>
                                <td class="text-xs text-grey-darkest py-1 px-2">
                                    <div class="text-xs">{{ project.sales_status ? project.sales_status : '-' }}</div>
                                </td>
                                <td class="text-xs text-grey-darkest py-1 px-2">
                                    <div class="text-xs">{{ project.account_manager ? project.account_manager : '-' }}</div>
                                </td>
                                <td class="text-xs text-grey-darkest py-1 px-2">
                                    <div class="text-xs">{{ project.estimator ? project.estimator : '-' }}</div>
                                </td>
                                <td class="text-xs text-grey-darkest py-1 px-2">
                                    <div class="text-xs">{{ project.bid_date ? project.bid_date : '-' }}</div>
                                </td>
                                <td class="text-xs text-grey-darkest py-1 px-2">
                                    <div class="text-xs">{{ project.base_bid }}</div>
                                </td>
                                <td class="text-xs text-grey-darkest py-1 px-2">
                                    <div class="text-xs">{{ project.contract_date ? project.contract_date : '-' }}</div>
                                </td>
                                <td class="text-xs text-grey-darkest py-1 px-2">
                                    <div class="text-xs">{{ project.contract_amount }}</div>
                                </td>
                            </tr>
                            </tbody>
                        </div>
                    </table>
                </div>
            </div>
            <div class="flex justify-center mt-3" v-if="projectPagination.meta.total > projectPagination.meta.per_page">
                <b-pagination
                    @change="goToPage"
                    v-model="projectPagination.meta.current_page"
                    :total-rows="projectPagination.meta.total"
                    :per-page="projectPagination.meta.per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                ></b-pagination>

            </div>
        </div>
    </div>
</template>

<script>

import Form from "../../utils/form";
import Multiselect from 'vue-multiselect';
import axios from "axios";
let autocomplete=null;
export default {
    name: 'recent-projects',
    props: ['company', 'masks', 'symbols', 'relatedCompanies', 'canEdit','contact', 'fieldLabels'],
    components: {Multiselect},

    data() {
        return {
            currentProjectOrder: {
                property: 'sequential_team_id',
                direction: 'desc'
            },
            projects: null,
            projectPagination: {
                data: [],
                meta: {},
                links: {},
            },
            projectFilter: '',
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.fetchProjects();
        },

        goToPage(page) {
            this.projectPagination.meta.current_page = page;
            this.fetchProjects();
        },

        fetchProjects() {
            this.loadingProjects = true;
            axios.get(route('api.company.projects', {
                company: this.company.id,
                contactId: this.contact.id,
                filter: this.projectFilter,
                page: this.projectPagination.meta.current_page,
                sortBy: this.currentProjectOrder.property,
                direction: this.currentProjectOrder.direction
            })).then(({data}) => {
                this.projects = data.data;
                this.projectPagination = data;
                this.loadingProjects = false;
            });
        },
        debounceFilterProjects: _.debounce(function (e) {
            // this.currentProjectOrder = {property: '', direction: ''}
            this.projectFilter = e.target.value;
            this.fetchProjects()
        }, 500),


        addProject() {
            window.location = route('project.create', {company_id: this.company.id,contact_id:this.contact.id});
        },

        editProject(project) {
            window.location = route('project.edit', {project: project.id, company_id: this.company.id});
        },

        sortByColumn(sortBy) {
            if (sortBy === this.currentProjectOrder.property) {
                this.currentProjectOrder.direction = (this.currentProjectOrder.direction === 'asc') ? 'desc' : 'asc'
            } else {
                this.currentProjectOrder.property = sortBy
                this.currentProjectOrder.direction = 'desc';
            }
            this.fetchProjects();
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
